import { render, staticRenderFns } from "./statement_income.vue?vue&type=template&id=37b7fdd0&scoped=true&"
import script from "./statement_income.vue?vue&type=script&lang=js&"
export * from "./statement_income.vue?vue&type=script&lang=js&"
import style0 from "./statement_income.vue?vue&type=style&index=0&id=37b7fdd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7fdd0",
  null
  
)

export default component.exports